export default "__VITE_ASSET__B$pGT7oQ__"